import { z } from 'zod'

export const CROP_ALIGNMENT = {
  CENTER: 'center',
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
  BOTTOM: 'bottom',
} as const

export const CropAlignmentSchema = z.nativeEnum(CROP_ALIGNMENT)

export type CropAlignment = z.infer<typeof CropAlignmentSchema>
